import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 *
 * @param project called when the observed value is not null
 * @returns Observable<Tout | undefined>
 */
export function nullOrMap<TIn, TOut>(project: (value: TIn) => TOut) {
  return (observable: Observable<TIn | null | undefined>) =>
    observable.pipe(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      map((r) => (r == null ? (null as null) : project(r!))),
    );
}

/**
 *
 * @param project called when the observed value is not null
 * @returns Observable<Tout | undefined>
 */
export function undefinedOrMap<TIn, TOut>(project: (value: TIn) => TOut) {
  return (observable: Observable<TIn | null | undefined>) =>
    observable.pipe(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      map((r) => (r == null ? (undefined as undefined) : project(r!))),
    );
}
